export const useAppHelper = () => {


    function getBuildNumberStorage() {
        const storedVersion = localStorage.getItem('appVersion');

        if (!storedVersion || storedVersion == "") {
            const date = new Date();
            return date.getFullYear().toString() + (date.getMonth().toString() + 1) + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString();

        } else {
            return storedVersion;
        }

    }

    async function checkForUpdate() {
        const storedVersion = localStorage.getItem('appVersion');
        try {
            const response = await fetch('/version.json?_' + new Date().getTime()); // Bust cache no fetch
            const {BUILD_NUMBER} = await response.json();

            if (storedVersion && storedVersion !== BUILD_NUMBER) {
                localStorage.setItem('appVersion', BUILD_NUMBER);
                //alert("vai atualizar");
                // @ts-ignore
                window.location.reload(true); // Força hard reload
            } else {
                localStorage.setItem('appVersion', BUILD_NUMBER);
            }
        } catch (error) {
            console.error('Erro ao verificar versão:', error);
        }
    }


    return {
        checkForUpdate,
        getBuildNumberStorage
    }
}